<template>
  <div>
    <f7-block>
      <h1 class="page-title">Seleziona Comune</h1>
    </f7-block>

    <f7-block class="sticky">
      <div class="input-wrapper">
        <f7-input
          id="search-municipality-input"
          type="text"
          :value="search"
          @input="onSearchMunicipalities"
          placeholder="Cerca Comune"
          class="input"
          clear-button
        ></f7-input>

        <f7-icon f7="search" size="24px" color="primary" class="icon"></f7-icon>
      </div>
    </f7-block>

    <f7-block>
      <f7-list v-if="loading">
        <f7-list-item
          v-for="n in 3"
          :key="n"
          class="skeleton-text skeleton-effect-blink"
          title="Full Name del comune"
        >
        </f7-list-item>
      </f7-list>

      <div class="error-wrapper" v-else-if="error">
        C'è stato un errore nel recupero della lista di comuni:
        <i>"{{ error.message }}"</i>
      </div>

      <f7-list v-else>
        <f7-list-item
          v-for="(m) in municipalities"
          :key="m.id"
          :title="m.name"
          @click="handleSelect(m)"
          :class="municipality === m.id ? 'selected' : ''"
        >
          <f7-icon
            v-if="municipality === m.id ? 'selected' : ''"
            slot="after"
            f7="checkmark_alt"
            size="18"
            color="primary"
          />
        </f7-list-item>

        <div
          v-if="municipalities.length === 0"
          class="no-results"
        >
          Nessun risultato
        </div>
      </f7-list>

    </f7-block>
  </div>
</template>

<style lang="less" scoped>
  .page-title {
    color: black;
  }

  .selected {
    color: var(--f7-theme-color);
  }

  .sticky {
    background-color: white;
    position: sticky;
    padding: 10px 20px;
    z-index: 100;
    top: 0;
  }

  .input-wrapper {
    background-color: white;
    position: relative;
    border: 1px solid #ccc;
    padding: 15px;
    padding-left: 40px;
    border-radius: 7px;

    .input {
      font-size: 16px;
  
      ::placeholder {
        color: #999;
      }
    }

    .icon {
      position: absolute;
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
    }
  }

  .no-results {
    color: #999;
  }
</style>

<script>
  import debounce from 'lodash.debounce'

  export default {
    props: {
      handleSelect: {
        type: Function,
        required: true,
      },
      municipality: {
        type: Number,
        default: null,
      },
    },

    data() {
      return {
        search: '',
      }
    },

    methods: {
      onSearchMunicipalities: debounce( function ({ target: { value } }) {
        this.search = value

        this.$store
          .dispatch('fetchMunicipalities', { search: value })

      }, 300),

      handleOpenPopup() {
        this.$$('#search-municipality-input input').focus()
      }
    },

    computed: {
      municipalities() {
        return this.$store.state.municipalities.data
      },

      loading() {
        return this.$store.state.municipalities.loading
      },

      error() {
        return this.$store.state.municipalities.error
      },
    },

    mounted() {
      this.$store
        .dispatch('fetchMunicipalities')
    },
  };
</script>
